<template>
  <div>
    <h1>{{ $t('Device inputs')}}</h1>
    <ul>
      <JsonItem v-for="(value, key) in inputs" :key="key" :itemKey="key" :itemValue="value" />
    </ul>
  </div>
</template>

<script>

import {
  BButton, BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BFormCheckbox
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { computed, ref, onMounted, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import { getSubstitute, getCategoriesBy } from '@/app/share/lists'
import axios from '@/libs/axios'
import JsonItem from '@/views/modules/device/tabs/JsonItem.vue'

export default {

  components: {
    JsonItem,
    BRow,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    BFormCheckbox,
    vSelect,
    OrbitSpinner
  },

  props: {
    device:{
      type: Number,
      required: true
    },
  },

  setup(props) {

    const s = store.state.device
    const inputs = ref({})

    const deviceData = computed(() => s.data)
    const errors = computed(() => s.errors)

    let timeoutId

    const getLastInputs = () => {
      axios.get(`device/${props.device}/getLastInputs`).then(res => {
        inputs.value = res.data

        timeoutId = setTimeout(() => {
          getLastInputs()
        }, 5000)
      })
    }

    getLastInputs()

    onUnmounted(() => {
      clearTimeout(timeoutId)
    })

    return {
      deviceData,
      inputs,
      errors,
    }
  }

}
</script>

<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}

li {
  background: #f4f4f4;
  margin: 5px 0;
  padding: 10px;
  border-radius: 5px;
  font-family: monospace;
}

</style>
